import { observer } from 'mobx-react'
import React, { forwardRef } from 'react'

import type { DefaultProps } from '@/types/common'

import { RadioGroupContext } from './context'
import S from './RadioGroup.style'

type Props<T> = {
  defaultValue?: unknown
  value?: T
  name?: string
  size?: 'small' | 'medium' | 'large' | 'auto'
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
} & DefaultProps

const RadioGroupWrap = <T,>(
  { value, children, name, size = 'small', onChange, className, style }: Props<T>,
  ref,
) => {
  const onRadioChange = (e: React.ChangeEvent<HTMLInputElement>) => onChange?.(e)

  return (
    <RadioGroupContext.Provider
      value={{
        value,
        name,
        ref,
        onChange: onRadioChange,
      }}
    >
      <div className={className} style={style} css={[S.basic, S.size[size]]}>
        {children}
      </div>
    </RadioGroupContext.Provider>
  )
}

RadioGroupWrap.displayName = 'RadioGroup'

const RadioGroup = forwardRef(RadioGroupWrap) as <T>(
  props: Props<T> & { ref?: React.ForwardedRef<HTMLInputElement> },
) => ReturnType<typeof RadioGroupWrap>

export default observer(RadioGroup)
